// Auto-generated by scripts/generate-registry.mjs from packages/modules/rhino_wave_pillow/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const rhino_wave_pillow: ModuleSchema = {
  "id": "rhino_wave_pillow",
  "uniqueId": "B3D_SP04B",
  "createdAt": "2026-10-23T00:00:00+07:00",
  "updatedAt": "2026-10-26T21:00:33+07:00",
  "label": "Rhino Wave Pillow",
  "description": "Type A structural woven-rattan pillow block on a flared shade-tier base, built headlessly by Rhino.Compute.",
  "category": "rattan",
  "tags": [
    "rhino-wave-pillow"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Form Width",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Form Depth",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Form Height",
      "min": 12,
      "max": 120,
      "default": 40,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 4,
      "max": 24,
      "default": 6,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0.5,
      "max": 5,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "faceCycles",
      "label": "Odd Cycles Per Face",
      "min": 3,
      "max": 15,
      "default": 7,
      "step": 2,
      "unit": "cycles",
      "enabled": true,
      "visible": true
    },
    {
      "key": "layerOverlap",
      "label": "Structural Layer Overlap",
      "min": 0,
      "max": 1.6,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.2,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.4,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "padThickness",
      "label": "Structural Pad Thickness",
      "min": 0.2,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bellyRadius",
      "label": "Belly Radius",
      "min": 0,
      "max": 25,
      "default": 13,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "middleRadius",
      "label": "Middle Radius",
      "min": 1,
      "max": 25,
      "default": 20,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bellyTension",
      "label": "Belly Tension",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 0.05,
      "unit": "ratio",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableBottomWatermark",
      "label": "Bottom Brand Watermark (Z=0)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableCavityWatermark",
      "label": "Anti-Theft Surface Brand Watermark",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "bottom_tier_pad_post_clearance61",
      "label": "Bottom Type A Tier + Pad Ø61 Post Clearance",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "solid_pillow_e27_base",
      "label": "Canonical C++ E27 Threaded Base",
      "default": "#0284c7",
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "e27_retaining_ring",
      "label": "Canonical C++ E27 Locking Ring",
      "default": "#f59e0b",
      "targetGroupIds": [
        5
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "label": "Rhino Wave Pillow with Canonical C++ E27 Base",
      "name": "Rhino Wave Pillow with Canonical C++ E27 Base",
      "color": "#64748b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "bottom_tier_pad_post_clearance61",
          "label": "Bottom Type A Tier + Pad Ø61 Post Clearance",
          "name": "Bottom Type A Tier + Pad Ø61 Post Clearance",
          "groupId": 0,
          "colorKey": "bottom_tier_pad_post_clearance61",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "solid_pillow_e27_base",
          "label": "Canonical C++ E27 Threaded Base",
          "name": "Canonical C++ E27 Threaded Base",
          "groupId": 4,
          "colorKey": "solid_pillow_e27_base",
          "defaultColor": "#0284c7",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        },
        {
          "id": "e27_retaining_ring",
          "label": "Canonical C++ E27 Locking Ring",
          "name": "Canonical C++ E27 Locking Ring",
          "groupId": 5,
          "colorKey": "e27_retaining_ring",
          "defaultColor": "#f59e0b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
